import 'react';
import { ScreenReaderOnly } from '../ScreenReaderOnly/index.js';
import { THead } from './styles.js';
import { testIds } from './testIds.js';
import { jsx } from '@emotion/react/jsx-runtime';

function TableHeader({
  visiblyHidden,
  ...rest
}) {
  return visiblyHidden ? jsx(ScreenReaderOnly, {
    "data-testid": testIds.hiddenTableHeader,
    as: "thead",
    children: rest.children
  }) : jsx(THead, {
    ...rest
  });
}

export { TableHeader };
